import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChatbotFormService {
  private formDataMap = new Map<string, any>();

  saveFormData(pageName: string, data: any) {
    this.formDataMap.set(pageName, data);
  }

  getFormData(pageName: string) {
    return this.formDataMap.get(pageName);
  }

  clearFormData(pageName?: string) {
    if (pageName) {
      this.formDataMap.delete(pageName);
    } else {
      this.formDataMap.clear();
    }
  }

  getAllFormData() {
    const result = {};
    this.formDataMap.forEach((value, key) => {
      result[key] = value;
    });
    return result;
  }
} 